<div>
  <div>
    <div class="submitButton">
        <button class="p-button l-form-button l-body-bold" type="submit"
            [disabled]="!allFieldsValid(this.form)" (click)="handleContinueClick()">
            Continue
        </button>
    </div>
    <div class="backButton" (click)="handleBackClick()">
        Back
    </div>
</div>
<app-toast></app-toast>
</div>
